import { render, staticRenderFns } from "./upcomingevent.html?vue&type=template&id=736b32e8&"
import script from "./upcomingevent.vue?vue&type=script&lang=js&"
export * from "./upcomingevent.vue?vue&type=script&lang=js&"
import style0 from "./upcomingevent.vue?vue&type=style&index=0&id=736b32e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports